import { render } from "./Taxonomies.vue?vue&type=template&id=bc097f18"
import script from "./Taxonomies.vue?vue&type=script&lang=js"
export * from "./Taxonomies.vue?vue&type=script&lang=js"

import "./Taxonomies.vue?vue&type=style&index=0&id=bc097f18&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__